const vehiclePowerUnit = [
  { label: 'PS', value: 'PS' },
  { label: 'KW', value: 'KW' }
]

export default vehiclePowerUnit
